<template>
    <div class="download-area show">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="dl-box">
                        <div class="dl-info">
                <span class="material-icons">
                    save_alt
                 </span>
                            <span id="total" data-total="">{{total !== null ? total : totalCart}}</span>
                            {{$t('file_in_download')}}
                        </div>
                        <div class="dl-button" v-if="lang == 'ja'">
                            <a href="/archives#/download">{{$t('download')}}</a>
<!--                            <router-link :to="'/download'">{{$t('download')}}</router-link>-->
                        </div>
                        <div class="dl-button" v-else>
                            <a href="/en/archives#/download">{{$t('download')}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AssetCart",
    props: {
        total: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            totalCart: this.total,
            lang: lang
        }
    },
    created() {
        if (this.totalCart === null) {
            let cart = localStorage.getItem('cart')
            if (cart) {
                let temp = cart.split(',')
                this.totalCart = temp.length
            } else {
                this.totalCart = 0
            }
        }
    }
}
</script>

<style scoped>

</style>
